import {LitElement, html} from 'lit';
import styles from './show-hide.component.scss?as=stylesheet';
import {defineCustomElement} from 'extensions/utils';

class ShowHide extends LitElement {
	static get styles () {
		return [styles];
	}

	static get properties () {
		return {
			hiddenLabel: {
				attribute: 'hidden-label',
				type: String
			},
			scrollAfterToggle: {
				attribute: 'scroll-after-toggle',
				type: Boolean
			},
			showContent: {
				attribute: 'show-content',
				type: Boolean
			},
			shownLabel: {
				attribute: 'shown-label',
				type: String
			}
		};
	}

	constructor () {
		super();
		this.showContent = false;
	}

	firstUpdated () {
		this.hidden = false;
	}

	toggleShowContent () {
		this.showContent = !this.showContent;

		if (this.scrollAfterToggle) {
			if (this.showContent) {
				this.scrollIntoView({behavior: 'smooth'});
			}
			else {
				this.parentElement?.scrollIntoView({
					behavior: 'smooth',
					block: 'end'
				});
			}
		}
	}

	render () {
		return html`
			<div class="root">
				<div ?hidden="${!this.showContent}">
					<slot></slot>
				</div>
				<div class="toggle-container">
					<button class="toggle-button" @click="${this.toggleShowContent}">${this.showContent ? this.shownLabel : this.hiddenLabel}</button>
				</div>
			</div>
		`;
	}
}

defineCustomElement('rb-show-hide', ShowHide);
